import { Button } from '@thesisedu/ui'
import { Upload } from '@thesisedu/ui/icons'
import React from 'react'

import { ImportModal } from './ImportModal'

export function ImportButton() {
  return <ImportModal trigger={<Button children={'Import Content'} icon={<Upload />} />} />
}
